export enum SourceIncome {
    WORK = 'RT',
    CAPITAL_RENTS = 'RC',
    NONE = 'SN',
    PUBLIC_BENEFITS = 'PP',
    PENSION = 'RJ',
    OTHER = 'TR',
}
